realmCommerceApp.controller("CartPaymentController", CartPaymentController);
/*@ngInject*/
function CartPaymentController($uibModal, $timeout, cartService, order, loaderService, formlyFieldsService, gtmEcommerceService, paymentFieldsService){
    let vm = this;
    vm.termsAccepted = false;
    vm.getCart = getCart;
    vm.gotoCart = gotoCart;
    vm.onSubmit = onSubmit;
    vm.showErrors = false;
    vm.orders = [];

    vm.model = {
        payment_method: 'CREDITCARD',
        termsConditionsPolicy: false,
        termsConditions: false,
        displayGrossPrice: null
    };
    vm.options = {};
    vm.fields = paymentFieldsService.getFields();
    vm.originalFields = angular.copy(vm.fields);
    vm.hasMultiplePaymentMethods = hasMultiplePaymentMethods();

    activate();

    function activate() {
        vm.order = order;
        let nonComplimentaryItems = vm.order.items.filter(item => item.product.price !== 0).length;
        if(nonComplimentaryItems == 0){
            vm.model.payment_method = 'COMPLIMENTARY';
        }else{
            vm.model.payment_method = order.payment_method || 'CREDITCARD';
        }
        vm.model.displayGrossPrice = order.displayGrossPrice;
    }

    function getCart() {
        return cartService.getCart();
    }

    function gotoCart() {
        return window.location.href = '/cart';
    }

    function onSubmit(event) {
        if (vm.form.$valid && vm.model.termsConditionsPolicy && vm.model.termsConditions) {
            loaderService.start();
            gtmEcommerceService.sendCheckoutStep(order.items, 'transactionProductDetails', 2, order.paymentMethod);
            $timeout(function(){
                vm.form.$$element.submit();
            });
        } else {
            event.preventDefault();
            angular.forEach(vm.form.$error.required, function (field) {
                field.$setDirty();
            });
            if (!vm.model.termsConditionsPolicy) {
                $uibModal
                    .open({
                        template: require('../layout/modal/terms.order.html'),
                        controller: 'CartPaymentModelController',
                        controllerAs: 'vm',
                        resolve: {}
                    }).result.then((data) => {
                    vm.model.termsConditionsPolicy = data;
                })
            }

            if (!vm.model.termsConditions) {
                $uibModal
                    .open({
                        template: require('../layout/modal/digital-content.order.html'),
                        controller: 'CartPaymentModelController',
                        controllerAs: 'vm',
                        resolve: {}
                    })
                    .result.then((data) => {
                    vm.model.termsConditions = data;
                })
            }
        }
        return false;
    }

    function hasMultiplePaymentMethods() {
        return vm.fields && vm.fields.length > 0
    }
}



// WEBPACK FOOTER //
// ./static/js/app/cart/cart.payment.controller.js